import * as React from "react";
import KuikaSvg from "../ui-kit/kuika-svg/kuika-svg";
import "./notice-banner.scss";

export type NoticeBannerSeverity = "warning" | "danger";

export interface INoticeBannerProps {
  severity: NoticeBannerSeverity;
  /** Short uppercase word in the pill: what kind of notice this is. */
  badge: string;
  title: string;
  description: React.ReactNode;
  /** Omit to make the notice permanent — no close button is drawn. */
  onClose?: () => void;
  /** Sits flush against the top of a full-width editor: no radius and no gap under it. */
  flush?: boolean;
}

const BADGE_ICON: Record<NoticeBannerSeverity, string> = {
  warning: "alert-triangle",
  danger: "ban"
};

// The notice strip an editor puts above its body: severity pill, title, description and an
// optional close. One object for every "heads up before you change this" banner in the designer.
export function NoticeBanner({ severity, badge, title, description, onClose, flush }: INoticeBannerProps) {
  const classes: string = [
    "kuika-notice-banner",
    `kuika-notice-banner--${severity}`,
    flush ? "kuika-notice-banner--flush" : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <div className="kuika-notice-banner__body">
        <div className="kuika-notice-banner__header">
          <span className={`kuika-notice-banner__badge kuika-notice-banner__badge--${severity}`}>
            <KuikaSvg type="common" name={BADGE_ICON[severity]} width={12} height={12} color="var(--dark-0)" />
            {badge}
          </span>
          <span className={`kuika-notice-banner__title kuika-notice-banner__title--${severity}`}>{title}</span>
        </div>
        <div className={`kuika-notice-banner__description kuika-notice-banner__description--${severity}`}>
          {description}
        </div>
      </div>
      {onClose && (
        <div className="kuika-notice-banner__actions">
          <button className="kuika-notice-banner__btn-close" onClick={onClose} title="Close">
            <KuikaSvg type="common" name="x" width={16} height={16} color="var(--dark-6)" />
          </button>
        </div>
      )}
    </div>
  );
}
